import React from 'react';
import InovxLoader from '@shared/global/InovxLoader';

const NoLicensePage: React.FC = () => (
    <div style={{ textAlign: 'center', padding: '80px 20px' }}>
        <h1>{InovxLoader.t('common:pages.noLicenseTitle')}</h1>
        <p>{InovxLoader.t('common:pages.noLicenseDescription')}</p>
        <a href="/">{InovxLoader.t('common:pages.returnToHome')}</a>
    </div>
);

export default NoLicensePage;
